<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div class="container">
            <div class="text">
              <div class="arabic-name">مستشفى الوزيرية الأهلي</div>
              <div class="english-name">Al-Waziria Private Hospital</div>
            </div>
            <div class="cards-space">
              <b-row>
                <b-col
                  lg="6"
                  sm="12"
                  md="12"
                  v-if="
                    this.$store.state.app.roles == 'reception' ||
                    this.$store.state.app.roles == 'super-admin'
                  "
                >
                  <b-link :to="{ name: 'Reception-Departments' }">
                    <b-card bg-variant="success" class="modify-hover">
                      <b-row>
                        <b-card-body
                          class="pb-0 pt-75 d-flex justify-content-between align-items-center"
                        >
                          <div class="truncate">
                            <h3 class="font-weight-bolder text-light">
                              {{ $t("reception.reception") }}
                            </h3>
                          </div>
                        </b-card-body>
                        <b-col cols="3" class="modify-illustration-parent">
                          <b-img
                            :src="
                              require('@/assets/images/illustration/reception.svg')
                            "
                            class="modify-illustration"
                            alt=" "
                          />
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-link>
                </b-col>
                <b-col
                  lg="6"
                  sm="12"
                  md="12"
                  v-if="
                    this.$store.state.app.roles == 'reception' ||
                    this.$store.state.app.roles == 'super-admin'
                  "
                >
                  <b-link :to="{ name: 'Reception-Lobby' }">
                    <b-card
                      style="filter: grayscale(60%)"
                      bg-variant="info"
                      class="modify-hover"
                    >
                      <b-row>
                        <b-card-body
                          class="pb-0 pt-75 d-flex justify-content-between align-items-center"
                        >
                          <div class="truncate">
                            <h3 class="font-weight-bolder text-light">
                              {{ $t("reception.hospital-check") }}
                            </h3>
                          </div>
                        </b-card-body>
                        <b-col class="modify-illustration-parent">
                          <b-img
                            :src="
                              require('@/assets/images/illustration/clinic.svg')
                            "
                            class="modify-illustration"
                            alt=" "
                          />
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-link>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BButton,
  BImg,
  BCardBody,
} from "bootstrap-vue";
import { getUserData } from "@/auth/utils";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BButton,
    BImg,
    BCardBody,
  },
  data() {
    return {
      // patient: "",
    };
  },
  mounted() {
    this.patient = getUserData();
    console.log(this.$store.state.app.roles, "this.patient");
  },
  methods: {},
};
</script>

<style>
.container {
  /* margin: 0; */
  display: grid;
  grid-template-columns: 0.75fr 3.5fr 0.75fr;
  grid-template-rows: 0.4fr 1fr 0.2fr;
  gap: 10px 5px;
  grid-auto-flow: row;
  grid-template-areas:
    "logo text logo2"
    "cards-space cards-space cards-space"
    "cards-space cards-space cards-space";
}

.logo {
  grid-area: logo;
}

.logo2 {
  grid-area: logo2;
}

.text {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 0.5fr 1.5fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "arabic-name arabic-name arabic-name"
    "arabic-name arabic-name arabic-name"
    "english-name english-name english-name";
  grid-area: text;
}

.arabic-name {
  font-family: "Arabic Typesetting", "Tahoma", "Times New Roman", "Arial", serif;
  grid-area: arabic-name;
  font-size: xxx-large;
  font-weight: 900;
  color: #070050;
  margin: auto;
}

.english-name {
  font-family: "Arabic Typesetting", "Tahoma", "Times New Roman", "Arial", serif;
  grid-area: english-name;
  font-size: xxx-large;
  font-weight: 900;
  margin: auto;
  color: #070050;
}

.cards-space {
  margin-top: 6rem;
  grid-area: cards-space;
}

.modify-img {
  display: block;
  height: 200px;
  width: 200px;
  margin-left: auto;
  margin-right: auto;
  /* margin-top: 2rem; */
  /* margin-bottom: 2rem; */
  cursor: pointer;
}

.modify-illustration-parent {
  display: flex;
  justify-content: right;
  align-items: center;
}

.modify-illustration {
  height: 6rem;
  width: 5rem;
  color: white;
}

@media (max-width: 1110px) {
  .container {
    /* margin: 0; */
    display: grid;
    grid-template-columns: 0.2fr 2fr 0.2fr;
    grid-template-rows: 0.2fr 1fr 0.2fr;
    gap: 10px 5px;
    grid-auto-flow: row;
    grid-template-areas:
      "logo text logo2"
      "cards-space cards-space cards-space"
      "cards-space cards-space cards-space";
  }

  .modify-img {
    display: block;
    height: 100px;
    width: 100px;
    margin-left: auto;
    margin-right: auto;
    /* margin-top: 2rem; */
    /* margin-bottom: 2rem; */
  }

  .arabic-name {
    font-size: xx-large;
  }

  .english-name {
    font-size: xx-large;
  }
}

@media (max-width: 740px) {
  .modify-img {
    height: 50px;
    width: 50px;
  }

  .container {
    display: grid;
    grid-template-columns: 0fr 2fr 0fr;
    grid-template-rows: 0.1fr 1fr 0.2fr;
    gap: 10px 5px;
    grid-auto-flow: row;
    grid-template-areas:
      "logo text logo2"
      "cards-space cards-space cards-space"
      "cards-space cards-space cards-space";
  }

  .modify-illustration {
    height: 4rem;
    width: 4rem;
    color: white;
  }
}

@media (max-width: 615px) {
  .arabic-name {
    font-size: x-large;
  }

  .english-name {
    font-size: x-large;
  }

  .modify-img {
    height: 0px;
    width: 0px;
  }

  .modify-illustration {
    height: 3rem;
    width: 3rem;
    color: white;
  }
}

@media (max-width: 389px) {
  .english-name {
    font-size: large;
  }
}
.modify-hover {
  box-shadow: rgb(38, 57, 77) 0px 20px 30px -10px;
}
.modify-hover:hover {
  opacity: 0.7;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset,
    rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;
}
</style>
